import { JourneyPicker } from '@common/features/JourneyPicker';
import { OnChangeParams } from '@common/features/JourneyPicker/JourneyPicker.types';
import { FC } from 'react';
import { JourneyParams } from 'shared-types/Common';
import { RoomRateAvailability } from 'shared-types/Room';

type DatesPickerProps = {
  journeyParams: JourneyParams;
  onChangeJourneyParams: (params: OnChangeParams) => void;
  availability?: RoomRateAvailability;
  showGuestsPicker?: boolean;
  rateCode?: string;
  isFetching?: boolean;
};

export const DatesPicker: FC<DatesPickerProps> = ({
  journeyParams,
  onChangeJourneyParams,
  showGuestsPicker,
  rateCode,
  isFetching,
}) => (
  <JourneyPicker
    journeyParams={journeyParams}
    onChange={onChangeJourneyParams}
    showGuestsPicker={showGuestsPicker}
    rateCode={rateCode}
    isFetching={isFetching}
  />
);
